export const LEAVE_DURATION = 180;
